import { BaseTag } from "mixs/base/base_mixin";

class Paginate extends BaseTag {
  init(){
    super.init();
    this.watch();
    this.setRawHtml();
  }
  onChangeStore(newVal, oldVal, objectPath) {
    super.onChangeStore(newVal, oldVal, objectPath)
    this.setRawHtml();
  }
  setRawHtml(){
    if(this.opts.html){
      this.rootElement().innerHTML = this.opts.html
    }else{
      this.rootElement().innerHTML = ''
    }
  }
}

riot.mixin("paginate", Paginate as riot.TagMixin);
